/* eslint-disable */

import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import PassRevenueModal from "./passRevenueModal";
import { templateStrings } from "../../../../Constant";
import { TableWrapper } from "../../../../shared/layout";
import { fetchAllOperatorPassRevenueAction } from "../../../../redux/action-creators/passRevenueActionCreator";


function PassRevenueList(props) {
  const { selectedDateFilter, refresh, setRefresh } = props;

  const dispatch = useDispatch();

  const content = useSelector(
    (state) => state.PassRevenue.allOperatorsPassRevenue.items || [],
  );
  const totalItems = useSelector(
    (state) => state?.PassRevenue?.allOperatorsPassRevenue?.totalItems ?? 0,
  );
  const headerLoader = useSelector((state) => state?.loadingBar?.header);
  const cityFilter = useSelector((state) => state.Cities.selectedCity);
  const operatorFilter = useSelector(
    (state) => state.Operators.selectedOperator,
  );

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageNo, setPageNo] = useState(0);
  const [sortBy, setSortBy] = useState("");
  const [selected, setSelected] = useState([""]);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState({});

  const templateString = templateStrings.reportPassRevenue;

  const getList = useCallback(() => {
    dispatch(
      fetchAllOperatorPassRevenueAction({
        pageNo,
        pageSize: rowsPerPage,
        operatorFilter,
        cityFilter,
        dateFilter: selectedDateFilter,
      }),
    );
  }, [
    dispatch,
    pageNo,
    rowsPerPage,
    operatorFilter,
    cityFilter,
    selectedDateFilter,
  ]);

  useEffect(() => {
    getList();
  }, [
    operatorFilter,
    cityFilter,
    JSON.stringify(selectedDateFilter),
    rowsPerPage,
    pageNo,
  ]);

  useEffect(() => {
    if (refresh) {
      getList();
      setRefresh(false);
    }
  }, [refresh]);

  const onSortToggle = useCallback((value, key) => {
    if (key === "sortBy") {
      setSortBy(value);
    }
  }, []);

  const handleAction = useCallback(
    (actionProps) => {
      setRowData(actionProps);
      setOpen(!open);
    },
    [open],
  );

  const handleChange = useCallback((input, value) => {
    switch (input) {
      case "pageNo":
        setPageNo(value);
        break;
      case "rowsPerPage":
        setRowsPerPage(value);
        break;
      case "selected":
        setSelected(value);
        break;
      default:
        break;
    }
  }, []);

  return (
    <>
      <TableWrapper
        content={!headerLoader && content}
        selected={selected}
        pageNo={pageNo}
        uniqueKey="busNumber"
        rowsPerPage={rowsPerPage}
        count={totalItems}
        handleChange={handleChange}
        templateString={templateString}
        selectionAllowed={false}
        actionName="Edit"
        handleAction={handleAction}
        onSortToggle={onSortToggle}
        sortBy={sortBy}
      />
      {open && (
        <PassRevenueModal
          open={open}
          setOpen={setOpen}
          rowData={rowData}
          setRefresh={setRefresh}
        />
      )}
    </>
  );
}
export default PassRevenueList;
